


//import aes from 'crypto-js/aes'
//import * as aesjs from '../libs/aes'

export default class UtilsChestionare {



    bubblesTypes = [
        {id:'bub_trimite_comp', nume:'Bubble Trimite Completatori'}
    ]

    tipLogare = {
        back_office: 'back_office',
        teren: 'teren',
        anonim: 'anonim',
        magazin: 'magazin'
    }


    culoriDepartamente = [
        'rgb(46, 136, 232)',
        'rgba(178, 64, 214, 0.91)',
        'rgb(70, 210, 82)',
        'rgba(239, 38, 38, 0.88)',
        'rgba(253, 73, 155, 0.9)',
        'rgb(200, 230, 42)',
        'rgb(54, 211, 220)',

    ]

    varstaClase = [
        '18-25 ani',
        '26-30 ani',
        '31-35 ani',
        '36-40 ani',
        '41-45 ani',
        '46-50 ani',
        '51-55 ani',
        '56-60 ani',
        '61-65 ani',
        '66-70 ani',
        '71-100 ani'
    ]

    venituriClase = [
        '100-500 euro',
        '501 - 800 euro',
        '801 - 1200 euro',
        '1201 - 2000 euro',
        '2000 - 5000 euro',
        '5000 - 10000 euro',
        '10000 - 100000 euro'
    ]


    tipIntrebari = [
        {
            id: 'radio',
            nume: 'Un Singur Raspuns'
        },
        {
            id: 'checkbox',
            nume: 'Raspuns Multiplu'
        },
        {
            id: 'text',
            nume: 'Text Liber'
        }
    ]

    typeOfCharts = [
        'Vertical',
        // 'Line', 
        // 'Bubble', 
        'Pie',
        'Horizontal',
        'Doughnut',
        // 'Polar Area'
    ]

    typeOfChartsImg = [
        'Horizontal',
        'Vertical',
    ]


    tipChestionare = {
        chestionareTipTeren: 'chestionare_teren',
        chestionareTipEmail: 'chestionare_email',
        chestionareTipMagazin: 'chestionare_magazin',
        chestionareTipCursuri: 'chestionare_cursuri'
    }

    statusChestionare = {
        inLucru: 'in_lucru',
        trimisAprobare: 'trimis_aprobare',
        aprobat: 'aprobat',
        respins: 'respins',
        lansat: 'lansat',
        completat: 'completat'
    }

    tipCont = {
        contLight: 'light',
        contFull: 'full'
    }

    studii = [
        { id: 'studii_inferioare', nume: 'Studii de Baza' },
        { id: 'studii_medii', nume: 'Studii Medii' },
        { id: 'studii_superioare', nume: 'Studii Superioare' },
    ]

    tipRaport = [
        { id: 'raport_individual', nume: 'Raport Individual' },
        { id: 'raport_complex', nume: 'Raport Complex' },
        { id: 'raport_total', nume: 'Raport Total' }
    ]
   


   

   

    generateRaspunsuri = () => {
        let counter = 100


        let raspunsuri = { id: 9, optiuniRaspuns: [] }

        for (let i = 1; i <= counter; i++) {
            raspunsuri.optiuniRaspuns.push({ Label: `${i}`, Puncte: i })

        }
        return raspunsuri
    }

    raspunsuriPredefinite = [
        {
            id: 1,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da', Puncte: 1 },
            { Label: 'Nu', Puncte: 0 }]
        },

        {
            id: 2,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da', Puncte: 1 },
            { Label: 'Ns/Nr', Puncte: 0 },
            { Label: 'Nu', Puncte: -1 }]
        },
        {
            id: 3,
            edit: 0,
            tip: 'img_single',
            optiuniRaspuns: [{ Label: null, Puncte: 0 },
            { Label: null, Puncte: 0 },
            { Label: null, Puncte: 0 }]
        },
        // {
        //     id: 4,
        //     edit: 0,
        //     tip: 'img_multiple',
        //     optiuniRaspuns: [{ Label: null, Puncte: 0 },
        //     { Label: null, Puncte: 0 },
        //     { Label: null, Puncte: 0 }]
        // },
        {
            id: 5,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da+', Puncte: 2 },
            { Label: 'Da', Puncte: 1 },
            { Label: 'Nu', Puncte: -1 },
            { Label: 'Nu-', Puncte: -2 }]
        },
        {
            id: 6,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da++', Puncte: 3 },
            { Label: 'Da+', Puncte: 2 },
            { Label: 'Da', Puncte: 1 },
            { Label: 'Ns/Nr', Puncte: 0 },
            { Label: 'Nu', Puncte: -1 },
            { Label: 'Nu-', Puncte: -2 },
            { Label: 'Nu--', Puncte: -3 }]
        },
        {
            id: 7,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: 'Da++', Puncte: 3 },
            { Label: 'Da+', Puncte: 2 },
            { Label: 'Da', Puncte: 1 },
            { Label: 'Nu', Puncte: -1 },
            { Label: 'Nu-', Puncte: -2 },
            { Label: 'Nu--', Puncte: -3 }]
        },
        {
            id: 8,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: '1', Puncte: -4 },
            { Label: '2', Puncte: -3 },
            { Label: '3', Puncte: -2 },
            { Label: '4', Puncte: -1 },
            { Label: '5', Puncte: 0 },
            { Label: '6', Puncte: 1 },
            { Label: '7', Puncte: 2 },
            { Label: '8', Puncte: 3 },
            { Label: '9', Puncte: 4 },
            { Label: '10', Puncte: 5 },]
        },
        {
            id: 9,
            edit: 0,
            tip: 'radio',
            optiuniRaspuns: [{ Label: '1', Puncte: -2 },
            { Label: '2', Puncte: -1 },
            { Label: '3', Puncte: 0 },
            { Label: '4', Puncte: 1 },
            { Label: '5', Puncte: 2 }]
        },
        {
            id: 10,
            edit: 0,
            tip: 'text',
            optiuniRaspuns: [{ Label: 'Raspuns Liber...', Puncte: 0 }]
        },

        // {id:11,
        //     edit:1,
        //     tip:'radio',
        // optiuniRaspuns:[{Label:'1', Puncte:0}]}



    ]

    randomData = (nr) => {
        let text = "";
        let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < nr; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    generateId = () => {
        return this.randomData(32);
    }

    getRandomColor = () => {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }


    encKey = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
    encCounter = 5

  



    renameKeysInObject = (obj, newKeys) => {
        const keyValues = Object.keys(obj).map(key => {
            const newKey = newKeys[key] || key;
            return { [newKey]: obj[key] };
        });

        return Object.assign({}, ...keyValues);
    }

    renameKeysInArray = (arr, newKeys) => {

        for (let el in arr) {
            // console.log('element este: ', arr[el])
            arr[el] = this.renameKeysInObject(arr[el], newKeys)
            // console.log('element devine ', arr[el])
        }

        return arr
    }

    translateHeaderData = (listaDeTradus, dictionar) => {
        //let dictionar = this.dictionary.licitatii.capLista

        let newKeys = {}
        for (let k in dictionar) {
            newKeys[k] = dictionar[k]
        }

        let newObject = this.renameKeysInArray(listaDeTradus, newKeys)
        return newObject
    }

    translateArray = (arr, dict) => {
        //  ATENTIE: VA MANIPULA PRIN REFERINTA ARRAYUL PRIMIT !!!

        for (let el in arr) {
            if (dict[arr[el]]) {
                arr[el] = dict[arr[el]]
            }
        }
        return arr
    }

   

   

    checkAccessToModule = (modul, functie, dictionar, activeLog = null) => {

        let _allowModule = this.checkModuleAvailable(modul, activeLog)

        if (_allowModule) {

            let _allowUser = this.checkUserRights(modul, functie, activeLog)

            if (_allowUser) {
                return {
                    hasAccess: true,
                    headMessage: '',
                    textMessage: ''
                }
            }
            else {
                return {
                    hasAccess: false,
                    headMessage: dictionar.comune.accesBlocatHead,
                    textMessage: dictionar.comune.accesBlocatText
                }
            }

        }
        else {
            return {
                hasAccess: false,
                headMessage: dictionar.comune.modulIndisponibilHead,
                textMessage: dictionar.comune.modulIndisponibilText
            }
        }
    }

    transformDataForSql = (data) => {


        let myDate = new Date(data)

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`

    }

    updateSqlNow = () => {

        let myDate = new Date()

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala)
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate()

        let hour = (myDate.getHours() < 10 ? '0' : '') + myDate.getHours()
        let minutes = (myDate.getMinutes() < 10 ? '0' : '') + myDate.getMinutes()

        return `${year}-${month}-${day} ${hour}:${minutes}:00`

    }

    ParseDataFromSql = (d) => String(d).substring(0, 10)
    ParseHourFromSql = (d) => String(d).substring(11, 16)

    defaultData = () => {
        let myDate = new Date()

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`
    }

    defaultDataPlus7Days = () => {
        let myDate = new Date()

        myDate.setDate(myDate.getDate() + 7);

        let year = myDate.getFullYear()
        let lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`
    }

    defaultData1Month = () => {
        let myDate = new Date()
      
        let year = myDate.getFullYear()
        let lunaNormala = myDate.setMonth(myDate.getMonth() + 1)
        lunaNormala = myDate.getMonth() + 1
        let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
        let day = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        return `${year}-${month}-${day}`
      }

    getDatePercent = (data, data2) => {

        let defaultDate = new Date()

        let myDate1 = new Date(data)

        let myDate2 = new Date(data2)




        let full = myDate2.getDate() - myDate1.getDate()

        if (defaultDate.getDate() <= myDate2.getDate()) {

            let today = defaultDate.getDate() - myDate1.getDate()

            // console.log('full :', full);
            //  console.log('today :', today);

            let percent = Math.floor((today / full) * 100)

            //    console.log('percent :', percent);

            return `${percent}%`
        } else {
            return `100%`
        }



    }

    statusulColor = (statusul) => {

        switch (statusul) {
            case 'Finalizata':
                return '#10aa2ac5'
            case 'InLucru':
                return '#ea550a';
            case 'Blocat':
                return 'red'
            default: return '#ea550a';
        }

    }




    statusText = (dbword) => {

        let obj = {
            Finalizata: this.dictionary.proiecte.status.finalizata,
            InLucru: this.dictionary.proiecte.status.inlucru,
            Blocat: this.dictionary.proiecte.status.blocat
        }


        return obj[dbword]


    }







    dataPrescurtataRomana = (data) => {

        let myDate = new Date(data);

        const luni = ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec']

        const an = myDate.getFullYear()
        const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        const luna = luni[myDate.getMonth()];
// console.log('data presc :>> ', `${zi} ${luna} ${an}`);
        return `${zi} ${luna} ${an}`

    }

    alfabet=['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z']

    dataPrescurtataEng = (data) => {

        let myDate = new Date(data);

        const luni = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        // const an = myDate.getFullYear()
        const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
        const luna = luni[myDate.getMonth()];

        return `${zi} ${luna}`

    }


    getAzi = (data) => {

        if (data !== null) {
            // console.log('data :>> ', data);
            let defaultData = this.defaultData()

            let defaultDataIeri = new Date(defaultData).setDate(new Date(defaultData).getDate() - 1)
            defaultDataIeri = new Date(defaultDataIeri)

            // console.log('defaultDataIeri :>> ', defaultDataIeri);
            // console.log('defaultData :>> ', defaultData);

            let year = defaultDataIeri.getFullYear()
            let lunaNormala = defaultDataIeri.getMonth() + 1
            let month = ((lunaNormala < 10 ? '0' : '') + lunaNormala);
            let day = (defaultDataIeri.getDate() < 10 ? '0' : '') + defaultDataIeri.getDate();
            let dataIeri = `${year}-${month}-${day}`

            if (defaultData === data) {
                // console.log('astazi :>> ');
                return 'Astazi'
            } else if (dataIeri === data) {
                
                return 'Ieri'
            } else {

                let myDate = new Date(data);

                const luni = ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec']
        
                const an = myDate.getFullYear()
                const zi = (myDate.getDate() < 10 ? '0' : '') + myDate.getDate();
                const luna = luni[myDate.getMonth()];
        // console.log('data presc :>> ', `${zi} ${luna} ${an}`);
                return `${zi} ${luna} ${an}`
           
            }
        }


    }
}